<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex v-if="totalStats.entities != undefined" lg3 sm6 xs12>
          <mini-statistic
            icon="location_city"
            :title="totalStats.entities || 0"
            :sub-title="$tc('entity',2)"
            color="indigo"
          ></mini-statistic>
        </v-flex>

        <v-flex v-if="totalStats.teams != undefined" lg3 sm6 xs12>
          <mini-statistic
            icon="group"
            :title="totalStats.teams || 0"
            :sub-title="$tc('team',2)"
            color="red"
          ></mini-statistic>
        </v-flex>
        <v-flex v-if="totalStats.users != undefined" lg3 sm6 xs12>
          <mini-statistic
            icon="person"
            :title="totalStats.users || 0"
            :sub-title="$tc('user',2)"
            color="light-blue"
          ></mini-statistic>
        </v-flex>
        <v-flex v-if="totalStats.tournaments != undefined" lg3 sm6 xs12>
          <mini-statistic
            icon="poll"
            :title="totalStats.tournaments || 0"
            :sub-title="$tc('tournament',2)"
            color="purple"
          ></mini-statistic>
        </v-flex>
        <v-flex v-if="totalStats.matches != undefined" lg3 sm6 xs12>
          <mini-statistic
            icon="forum"
            :title="totalStats.matches || 0"
            :sub-title="$tc('match',2)"
            color="indigo"
          ></mini-statistic>
        </v-flex>
        <v-flex md7 xs12 px-2>
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <span class="title">{{$t('actStats')}}</span>
            </v-flex>
            <v-flex xs12 sm6 pt-0>
              <v-autocomplete
                v-model="actId"
                :items="actSelectList"
                :label="$t('select', {field: $tc('act')})"
                clearable
                :loading="loading"
                @change="onChangeAct"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="averageStats" xs12>
              <bar-chart :title="averageStats.title" :data="averageStats.stats" :twoBars="false"></bar-chart>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex v-if="showUsersStats" d-flex md5 xs12 px-2>
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <span class="title">{{$t('userStats')}}</span>
            </v-flex>
            <v-flex xs12 py-0>
              <v-autocomplete
                v-model="entityId"
                :items="entitySelectList"
                :label="$t('select', {field: $tc('entity')})"
                clearable
                :loading="loading"
                @change="onChangeEntity"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 py-0>
              <v-menu
                v-model="menu_start"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="start_date"
                    :label="$t('startAt')"
                    prepend-icon="event"
                    readonly
                    clearable
                    @click:clear="startDate = null"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="menu_start = false"
                  :first-day-of-week="1"
                  @change="onChangeEntity"
                  locale="es-ES"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 py-0>
              <v-menu
                v-model="menu_end"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="end_date"
                    :label="$t('endAt')"
                    prepend-icon="event"
                    readonly
                    clearable
                    @click:clear="endDate = null"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="menu_end = false"
                  :first-day-of-week="1"
                  @change="onChangeEntity"
                  locale="es-ES"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex v-if="usersStats.length" d-flex xs12>
              <donut-chart :title="$tc('user',2)" :data="usersStats"></donut-chart>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 px-2>
          <v-layout row wrap>
            <v-flex xs12 pb-0>
              <span class="title">{{$t('tournamentStats')}}</span>
            </v-flex>
            <v-flex xs12 sm6 md4 py-0>
              <v-autocomplete
                v-model="tournamentId"
                :items="tournamentSelectList"
                :label="$t('select', {field: $tc('tournament')})"
                clearable
                :loading="loading"
                @change="onChangeTournament"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="tournament && tournament.type == 'teams'" xs12 sm6 md4 py-0>
              <v-autocomplete
                v-model="teamId"
                :items="teams"
                :label="$t('select', {field: $tc('team')})"
                clearable
                @change="onChangeTournament"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-else-if="tournament && tournament.type" xs12 sm6 md4 py-0>
              <v-autocomplete
                v-model="userId"
                :items="users"
                :label="$t('select', {field: $tc('user')})"
                clearable
                @change="onChangeTournament"
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="averagesPhases" d-flex xs12 pa-2 py-0>
              <stacked-line-chart
                :title="averagesPhases.title"
                :legend="averagesPhases.categories"
                :x-axis-label="averagesPhases.phases"
                :series="averagesPhases.series"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import MiniStatistic from './widgets/statistic/MiniStatistic'
import BarChart from '@/components/widgets/chart/BarChart'
import DonutChart from '@/components/widgets/chart/DonutChart'
import StackedLineChart from '@/components/widgets/chart/StackedLineChart'
import { dateFormat, formatDate } from '@/helpers/dateHelper'
export default {
  components: {
    MiniStatistic,
    BarChart,
    DonutChart,
    StackedLineChart
  },
  data: () => ({
    actId: '',
    entityId: '',
    tournamentId: '',
    teamId: '',
    userId: '',
    menu_start: false,
    startDate: null,
    menu_end: false,
    endDate: null
  }),
  created() {
    this.initData()
    this.setClear()
  },
  watch: {
    statusOfButton: function(val) {
      if (val) this.initData()
    },
    tournamentId: function(val) {
      this.teamId = ''
      this.userId = ''
      this.setClearPhasesAverages()
    }
  },
  computed: {
    ...mapState({
      totalStats: state => state.stats.totalStats,
      totalUsers: state => state.stats.totalUsers,
      loading: state => state.stats.loading,
      actSelectList: state => state.acts.listSelect,
      entitySelectList: state => state.entities.listSelectEntities,
      statusOfButton: state => state.events.status,
      listUsers: state => state.users.listSelectUsers,
      tournamentSelectList: state => state.tournaments.listSelect,
      listTeams: state => state.teams.listSelectTeams,
      authUser: state => state.authentication.user,
      tournamentSelected: state => state.tournaments.selected
    }),
    ...mapGetters({
      averageStats: 'stats/averageStats',
      usersStats: 'stats/usersStats',
      averagesPhases: 'stats/averagesPhases'
    }),

    tournament() {
      if (!this.tournamentId) return null
      return this.tournamentSelected
    },
    users() {
      if (
        !this.tournament ||
        !this.tournament.users ||
        this.tournament.type == 'teams'
      )
        return []
      let users = []
      if (this.isParticipant) {
        users = this.listUsers.filter(user => user.value == this.authUser._id)
      } else {
        users = this.listUsers.filter(user =>
          this.tournament.users.some(item => item.userId == user.value)
        )
      }
      return users
    },
    teams() {
      if (
        !this.tournament ||
        !this.tournament.teams ||
        this.tournament.type != 'teams'
      )
        return []
      return this.listTeams.filter(team =>
        this.tournament.teams.some(item => item.teamId == team.value)
      )
    },
    start_date() {
      return formatDate(this.startDate)
    },
    end_date() {
      return formatDate(this.endDate)
    },
    showUsersStats() {
      return this.isAdmin || this.hasRole('entities')
    }
  },
  methods: {
    ...mapActions({
      setTotalStats: 'stats/setTotalStats',
      setTotalUsers: 'stats/setTotalUsers',
      setAverages: 'stats/setAverages',
      setClear: 'stats/setClear',
      setClearAverages: 'stats/setClearAverages',
      setClearUsersStats: 'stats/setClearUsersStats',
      setClearPhasesAverages: 'stats/setClearPhasesAverages',
      setAveragesPhases: 'stats/setAveragesPhases',
      setStatus: 'events/setStatus',
      initEntities: 'entities/setInitSelect',
      initActs: 'acts/setInitSelect',
      initTournaments: 'tournaments/setInitSelect',
      initUsers: 'users/setInitSelect',
      initTeams: 'teams/setInitSelect',
      getOneTournament: 'tournaments/setOne'
    }),
    onChangeAct(actId) {
      this.setClearAverages()
      if (actId) {
        this.setAverages({ actId })
      }
    },
    onChangeEntity() {
      this.setClearUsersStats()

      let params = {}
      if (this.entityId) {
        params.entityId = this.entityId
      }
      if (this.startDate) {
        params.startDate = this.startDate
      }
      if (this.endDate) {
        params.endDate = this.endDate
      }

      this.setTotalUsers(params)
    },
    onChangeTournament(val) {
      this.setClearPhasesAverages()
      if (!val) return

      let params = {}
      params.tournamentId = this.tournamentId

      if (this.userId) {
        params.userId = this.userId
      } else if (this.teamId) {
        params.teamId = this.teamId
      }
      if (this.tournamentId) this.getOneTournament(this.tournamentId)
      this.setAveragesPhases(params)
    },
    async initData() {
      this.setStatus(true)
      if (this.showUsersStats) {
        this.setTotalUsers()
      }

      await Promise.all([
        this.setTotalStats(),
        this.initEntities(),
        this.initActs(),
        this.initTournaments(),
        this.initTeams(),
        this.initUsers()
      ]).finally(() => this.setStatus(false))
    }
  }
}
</script>
